import { useTranslation } from "react-i18next";
import { useFitContentWidth } from "../../../../../../logic/hooks/useFitContentWidth";
import "./BetMultiplierBanner.scss";

interface BetMultiplierBannerProps {
    multiplier: number;
    visible: boolean;
}

export function BetMultiplierBanner({
    multiplier,
    visible,
}: BetMultiplierBannerProps) {
    const { t } = useTranslation();
    const label = t("slotMachine.controls.allWins", {
        betMultiplier: multiplier,
    });
    const fit = useFitContentWidth(label, { fitHeight: true });

    return (
        <div
            className={["bet-multiplier-banner", visible && "is-visible"]
                .filter(Boolean)
                .join(" ")}
            role="status"
            aria-live="polite"
            aria-atomic="true"
            aria-hidden={!visible}
        >
            <svg
                className="bet-multiplier-banner__shape"
                viewBox="0 0 1291.05957 221"
                aria-hidden="true"
                focusable="false"
            >
                <path
                    d="M0 0H1291.05957L1266.05957 221H25Z"
                    fill="#c62a03"
                    stroke="#521201"
                    strokeWidth="20"
                    paintOrder="stroke fill"
                />
            </svg>
            <span
                className="bet-multiplier-banner__label-container"
                ref={fit.containerRef}
            >
                <span
                    className="bet-multiplier-banner__label"
                    ref={fit.contentRef}
                >
                    {label}
                </span>
            </span>
        </div>
    );
}
